export interface LicenseModel {
  owner: string; // Кому выдана лицензия
  modules: string; // Доступные модули
  begins: any; // Дата начала действия
  ends: any; // Дата окончания действия
  users: string; // Пользователь
  valid: boolean; // Валидность
}
